/**
 * Engraving Mask feature constants.
 */

export const DEFAULT_OUTPUT_SIZE = 512
export const EDITOR_DISPLAY_SIZE = 400
export const ZOOM_STEP = 0.15
export const ZOOM_MIN = 0.2
export const ZOOM_MAX = 3
export const ROTATION_MIN = -180
export const ROTATION_MAX = 180
export const STROKE_STYLE = 'rgba(255,255,255,0.75)'
export const STROKE_WIDTH = 3
export const HEART_PATH_STEPS = 60
/** Padding from canvas edge to shape (same for all shapes); small value = shapes almost fill container */
export const SHAPE_PADDING = 8

/**
 * Heart only: multiplier after fitting the path bbox to innerSize (like other shapes). 1 = fill innerSize;
 * below 1 adds margin; above 1 may clip at the padded region edges.
 */
export const HEART_DISPLAY_SCALE = 1

/**
 * Rectangle (L/M) SVG paths: same idea as heart after bbox fit.
 */
export const RECT_SVG_DISPLAY_SCALE = 1

/** Oval: SVG viewBox 0 0 411.34 539.64, ellipse rx=168.88 ry=253.05 */
export const OVAL_RX_RY_RATIO = 168.88 / 253.05

export const SHAPES = ['circle', 'heart', 'oval', 'rectangle-wide', 'rectangle-square']

export const NUM_PARTS_OPTIONS = [
  { text: '1', value: 1 },
  { text: '2', value: 2 },
  { text: '3', value: 3 },
]

export const DIRECTION_OPTIONS = [
  { text: 'Vertical', value: 'vertical' },
  { text: 'Horizontal', value: 'horizontal' },
]

export const SHAPE_OPTIONS = [
  { text: 'Circle', value: 'circle' },
  { text: 'Heart', value: 'heart' },
  { text: 'Oval', value: 'oval' },
  { text: 'Rectangle (L)', value: 'rectangle-wide' },
  { text: 'Rectangle (M)', value: 'rectangle-square' },
]

export const SIZE_OPTIONS = [
  { text: '256×256', value: 256 },
  { text: '512×512', value: 512 },
  { text: '1024×1024', value: 1024 },
]

export const SPACING_OPTIONS = [
  { text: 'None', value: 0 },
  { text: 'Small (4px)', value: 4 },
  { text: 'Medium (8px)', value: 8 },
  { text: 'Large (12px)', value: 12 },
  { text: 'Extra (16px)', value: 16 },
]
